import { Reducer } from "redux";
import { Client } from "../../models/client/Client";
import { ClientSubsidy } from "../../models/client/ClientSubsidy";
import { CardInfo } from "../../models/client/CardInfo";
import Coupon from "../../models/coupon/Coupon";
import { GetCardInfoActionTypes, GetClientActionTypes, GetClientCouponsActionTypes, GetClientSubsidiesActionTypes } from "./types";

export interface ClientState {
    client?: Client;
    coupons?: Coupon[];
    subsidies: ClientSubsidy[];
    cardInfo?: CardInfo;
}

const unloadedState: ClientState = { client: undefined, coupons: undefined, subsidies: [], cardInfo: undefined };

export const clientReducer: Reducer<ClientState> = (state: ClientState | undefined, action): ClientState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case GetClientActionTypes.SUCCESS:
            return { ...state, client: { ...action.payload } };
        case GetClientCouponsActionTypes.SUCCESS:
            return { ...state, coupons: [...action.payload] };
        case GetClientSubsidiesActionTypes.SUCCESS:
            return { ...state, subsidies: [...action.payload] };
        case GetCardInfoActionTypes.SUCCESS:
            return { ...state, cardInfo: {...action.payload} };
        default:
            return state;
    }
};
